// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"styles_backdrop__1lnCI","paper":"styles_paper__uWPCj"};